/* eslint-disable */
import React, { useRef, useState, useEffect } from "react";
import { Tabs } from "antd";
import { useSearchParams } from "react-router-dom";
import "./style.scss";
import Heading from "../../../components/Heading";
import sorting from "../../../assests/images/SVG/sort-white.svg";
import McnShipmentList from "../../../components/McnShipmentList";
import { ShipmentStatus } from "../OutBondMcn";
import { MCN_TITLES } from "../../../constants/mcnConstants";

// Tab configurations based on requirements
const tabConfigs = [
  {
    key: "1",
    label: MCN_TITLES.EXPECTING,
    currentOperationCode: [ShipmentStatus.MANIFESTED, ShipmentStatus.INSCANNED, ShipmentStatus.BAGGED, ShipmentStatus.HUB_OUTSCAN, ShipmentStatus.IN_BAG_OUTSCAN, ShipmentStatus.IN_BAG_INSCAN, ShipmentStatus.INSCANNED_AT_TRANSIT],
    checkDestinationHub: true
  },
  {
    key: "2",
    label: MCN_TITLES.AT_HUB,
    currentOperationCode: [ShipmentStatus.HUB_INSCANNED],
    checkDestinationHub: true
  },
  // {
  //   key: "3",
  //   label: MCN_TITLES.SENT_FOR_DELIVERY,
  //   currentOperationCode: [ShipmentStatus.OUTSCAN_TO_3PL],
  //   checkDestinationHub: true
  // },
  {
    key: "3",
    label: MCN_TITLES.DELIVERY_PENDING,
    currentOperationCode: [ShipmentStatus.OUT_FOR_DELIVERY, ShipmentStatus.ATTEMPTED, ShipmentStatus.RTO_OUT_FOR_DELIVERY, ShipmentStatus.RETURN_REVOKED, ShipmentStatus.undelivered, ShipmentStatus.OUTSCAN_TO_3PL],
    checkDestinationHub: true
  },
  {
    key: "4",
    label: MCN_TITLES.DELIVERED,
    currentOperationCode: [ShipmentStatus.DELIVERED, ShipmentStatus.RTO_DELIVERED], // No filter - show all
    checkDestinationHub: true
  }
];

const Index = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Get last selected tab from URL or default to "1"
  const getLastSelectedTab = () => {
    const tabParam = searchParams.get("tab");
    return tabParam && tabConfigs.find(tab => tab.key === tabParam) ? tabParam : "1";
  };

  const [activeTab, setActiveTab] = useState(getLastSelectedTab);
  const mcnListRefs = useRef({});

  // Handle tab change and trigger API call
  const handleTabChange = (activeKey) => {
    setActiveTab(activeKey);

    // Update URL with selected tab
    setSearchParams({ tab: activeKey });

    // Call API for the newly selected tab
    if (mcnListRefs.current[activeKey]) {
      mcnListRefs.current[activeKey].fetchData();
    }
  };

  // Set ref for each McnShipmentList component
  const setMcnListRef = (key, ref) => {
    if (ref) {
      mcnListRefs.current[key] = ref;
    }
  };

  // Call API for the last selected tab on component mount
  useEffect(() => {
    // Small delay to ensure refs are set
    const timer = setTimeout(() => {
      if (mcnListRefs.current[activeTab]) {
        mcnListRefs.current[activeTab].fetchData();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [activeTab]);

  return (
    <div className="p2 consolidated-tab-cntr">
      <Heading
        title={"MCN Inbound"}
        imgSrc={sorting}
        navigateTo={"/mcn"}

      />

      <Tabs
        defaultActiveKey={activeTab}
        activeKey={activeTab}
        onChange={handleTabChange}
        items={tabConfigs.map(config => ({
          key: config.key,
          label: (
            <div className="tab-label">
              <div className="tab-title">{config.label}</div>
            </div>
          ),
          children: (
            <McnShipmentList
              // ref={(ref) => setMcnListRef(config.key, ref)}
              title={config.label}
              bookingStatuses={config.statuses}
              checkDestinationHub={config.checkDestinationHub}
              currentOperationCode={config.currentOperationCode}
              autoFetch={false}
            />
          )
        }))}
        className="mcn-tabs"
      />
    </div>
  );
};

export default Index;
